export const name = "IEEE_DIVIDE";
export const summary = `Divides \`X\` by \`Y\`, but doesn't generate errors for division by zero or overflow.`;
export const reference = `
## IEEE_DIVIDE

Divides \`X\` by \`Y\`, but doesn't generate errors for division by zero or overflow.

\`\`\`
IEEE_DIVIDE(X, Y)
\`\`\`

### Description

Divides X by Y; this function never fails. Returns\`FLOAT64\`. Unlike the division operator (/), this function doesn't generate errors for division by zero or overflow.



| X | Y | IEEE\\_DIVIDE(X, Y) |
| --- | --- | --- |
| 20.0 | 4.0 | 5.0 |
| 0.0 | 25.0 | 0.0 |
| 25.0 | 0.0 | \`+inf\` |
| -25.0 | 0.0 | \`-inf\` |
| 0.0 | 0.0 | \`NaN\` |
| 0.0 | \`NaN\` | \`NaN\` |
| \`NaN\` | 0.0 | \`NaN\` |
| \`+inf\` | \`+inf\` | \`NaN\` |
| \`-inf\` | \`-inf\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
